import { RoleWithPrivileges } from "src/types/userTypes";
// available rules for each user role
import axios from "axios";
import { useQuery } from "react-query";
import { nuclearn_api_url } from "src/App";

export const getPermissionsSet = (): Promise<RoleWithPrivileges[]> => {
  return axios.get(`${nuclearn_api_url}/auth/rules`).then((res) => {
    return res.data;
  });
};

export const usePermissionSet = () => {
  return useQuery("rules", () => getPermissionsSet(), {
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 10, // 10 minutes
    cacheTime: 1000 * 60 * 15, // 15 minutes
    retry: false,
  });
};

export const getLicensedProducts = (): Promise<string[]> => {
  return axios.get(`${nuclearn_api_url}/auth/licensed-products`).then((res) => {
    return res.data;
  });
};

/** The one react-query key for GET /auth/licensed-products. Every reader
 * (role gates, licensed rollout gates, the license console) shares it, so the
 * invalidation after a license upload refreshes all of them at once. */
export const LICENSED_PRODUCTS_QUERY_KEY = "licensedProducts";

export const useGetLicensedProduct = () => {
  return useQuery<string[], Error>(
    LICENSED_PRODUCTS_QUERY_KEY,
    getLicensedProducts,
    {
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 10, // 10 minutes
      cacheTime: 1000 * 60 * 15, // 15 minutes
      retry: false,
    },
  );
};
